import { render, staticRenderFns } from "./ViewFeature.vue?vue&type=template&id=1941d5e6&"
import script from "./ViewFeature.vue?vue&type=script&lang=js&"
export * from "./ViewFeature.vue?vue&type=script&lang=js&"
import style0 from "./ViewFeature.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports